import { ShoppingCartAmountService } from 'application/services/shopping-cart-amount'
import { api } from 'infra/adapters/http-client-adapter'

export const handleShoppingCartAmount = new ShoppingCartAmountService(api)
